import React, { useState } from 'react'
import { Form } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import MultiRangeSlider from "multi-range-slider-react";
import { FaRupeeSign } from 'react-icons/fa';
import feedback from '../../../assets/img/notify.jpg';
import { useEffect } from 'react';
import { getMakeAnOfferListing, makeanOfferListFilter } from '../../../Redux/MakeanOffer/action';
import moment from 'moment';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { getTaskCategoryList } from '../../../Redux/Task/action';
import { IMAGE_URL } from '../../../api';
import { date_range } from '../../functions';


const MakeanOfferListing = () => {


  const { state } = useLocation();
  const navigate = useNavigate();
  const [categories, setCategories] = useState();
  const [filterbydate, setFilterbyDate] = useState('All');
  const [tasks, setTasks] = useState([])
  const [minValue, set_minValue] = useState(0);
  const [maxValue, set_maxValue] = useState(75);
  const handleInput = (e) => {
    set_minValue(e.minValue);
    set_maxValue(e.maxValue);
  };
  useEffect(() => {
    let formData = new FormData();
    formData.append('status_object', 2);
    // formData.append('sort_order', 1);
    // formData.append('category', 1);
    getMakeAnOfferListing({ formData })((response) => {
      if (response && response.status) {
        setTasks(response?.data?.data)
      }
    });
    getTaskCategoryList()((response) => {
      if (response && response.status) {
        setCategories(response?.data?.data)
      }
    });

  }, []);

  const validationSchema = Yup.object().shape({

  });
  const formik = useFormik({
    initialValues: {
      filterdate_from: "",
      filterdate_to: "",
      minValue: "",
      maxValue: "",
      status_object: "",
      category: "",
      sort_order: "",
      sub_category: "",
      limit: "",

    },
    validationSchema,
    onSubmit: (values) => {
      let formData = new FormData();
      values.filterdate_from &&
        formData.append("filterdate_from", values.filterdate_from);
      values.filterdate_to &&
        formData.append("filterdate_to", values.filterdate_to);
      formData.append("filterprice_from", minValue);
      formData.append("filterprice_to", maxValue);
      // formData.append("status_object", values.status_object);
      formData.append("category", values.category);
      formData.append("sort_order", values.sort_order);
      // formData.append("sub_category", values.sub_category);
      // formData.append("limit", values.limit);
      makeanOfferListFilter({ formData })((response) => {
        if (response && response.status) {
          // navigate('/')
          setTasks(response?.data?.data)
          localStorage.setItem('filter_category', values.category)
          localStorage.setItem('filter_sort_order', values.sort_order)
          localStorage.setItem('filter_date', filterbydate)
          // localStorage.setItem('filter_date',values.sort_order)
        }
      });
    },
  });
  const clearAll = () => {

    formik.setValues({
      filterdate_from: "",
      filterdate_to: "",
      minValue: "",
      maxValue: "",
      status_object: "",
      category: "",
      sort_order: "",
      sub_category: "",
      limit: "",
    });
    set_minValue(0);
    set_maxValue(75);
    localStorage.removeItem('filter_category');
    localStorage.removeItem('filter_sort_order');
    localStorage.removeItem('filter_date');
  }
  const handleSelectChange = (e) => {
    let from = "";
    let to = "";
    setFilterbyDate(e.target.value)
    if (e.target.value == "Today") {

      from = date_range("Today")[0]
      to = date_range("Today")[1]
    }
    else if (e.target.value == "Weekly") {

      from = date_range("Weekly")[0]
      to = date_range("Weekly")[1]
    }
    else if (e.target.value == "Monthly") {
      from = date_range("Monthly")[0]
      to = date_range("Monthly")[1]

    } else if (e.target.value == "All") {
      from = undefined
      to = undefined
    }
    formik.setValues({
      ...formik.values,
      filterdate_from: from,
      filterdate_to: to
    })
  }
  useEffect(() => {
    setFilterbyDate(localStorage.getItem('filter_date') || 'All')
  }, [])
  return (
    <React.Fragment>
      <Header />
      <section>
        <div className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-md-12 my-auto">
                <h1>Make an Offer</h1>
                <ul className="trail-items">
                  <li className="trail-item trail-begin">
                    <Link to="/">
                      <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                    </Link>
                  </li>
                  <li className="trail-item trail-end">
                    <span itemProp="item"><span itemProp="name"> Make an Offer</span></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='logodesign-details'>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 col-lg-2 sidebar-filter">
              <Form onSubmit={formik.handleSubmit}>
                <div className='logodesign-details-filter mb-4'>
                  <h3 className="mt-0 mb-3">Filters</h3>
                  <h4 onClick={() => { clearAll() }} className="mt-0 mb-3" role="button">CLEAR ALL</h4>
                </div>
                {/* <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Control type="text" name='search' placeholder="Search key" />
                </Form.Group> */}
                <Form.Select value={formik.values.category || ""} aria-label="Default select example" className="mb-3" name='category' onChange={formik.handleChange}>
                  <option value='' disabled hidden>Choose category</option>
                  {categories?.map(category =>
                    <option value={category?.id}>{category?.name}</option>
                  )}

                </Form.Select>
                <Form.Select value={formik.values.sort_order || ""} aria-label="Default select example" name='sort_order' onChange={formik.handleChange} className="mb-3">
                  <option value='' disabled hidden>Sort by</option>
                  <option value="1" >Ascending </option>
                  <option value="2">Descending</option>

                </Form.Select>
                <Form.Select value={filterbydate} aria-label="Default select example" onChange={(e) => handleSelectChange(e)} className="mb-3">
                  <option>Filter by</option>
                  <option value="All" >All </option>
                  <option value="Today">Daily</option>
                  <option value="Weekly">Weekly</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Period">Period</option>

                </Form.Select>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Price Range</Form.Label>
                  <div className='range-value'>{minValue} <FaRupeeSign size={16} /> - {maxValue} <FaRupeeSign size={16} /></div>
                  <MultiRangeSlider
                    className='multi-price-ranger'
                    min={0}
                    max={20000}
                    step={5}
                    minValue={minValue}
                    maxValue={maxValue}
                    ruler={false}
                    barInnerColor={"#012970"}
                    onInput={(e) => {
                      handleInput(e);
                    }}
                  />
                </Form.Group>

                <div className='filter-btn mt-4'>
                  <button type="submit" className="btn btn-primary mb-4">Apply Filter</button>
                </div>


              </Form>
            </div>
            <div className='col-lg-10 col-md-8'>
              <section className="mytask-buyer section-bg p-0">
                <div className="container">
                  <div className="row">
                    <React.Fragment>
                      {tasks?.map((task, index) =>
                        <div className="col-lg-5">
                          <div className='make-offer' onClick={() => navigate('/makeanoffer', { state: { data: task } })}>
                            <div className="member d-flex align-items-start">
                              <div className='col-lg-3'>
                                <div className="pic"><img src={IMAGE_URL + task?.image[0]?.image} className="img-fluid" alt="" />
                                </div>
                              </div>
                              <div className='col-lg-9'>
                                <div className="member-info">
                                  <div className='task_title_main'>
                                    <h4>{task?.title}</h4>
                                  </div>
                                  {task?.location == "" ?
                                    <></>
                                    :
                                    <p><i class="bi bi-geo-alt-fill me-2"></i> {task?.location}</p>
                                  }
                                  <p><i className="bi bi-calendar me-2"></i> {moment(task?.date_choice).format('ll')}</p>
                                  <p><i className="bi bi-clock me-2"></i> {task?.time_slot == 1 ? "Before 10 AM" : task?.time_slot == 2 ? "10 AM - 2 PM" : task?.time_slot == 3 ? "2 PM - 6 PM" : task?.time_slot == 4 && "After 6 PM"}</p>
                                  <div className='badge-w-set'>
                                    <span className="badge badge-light-danger me-2">{task?.status[0]?.status == 1 ? "Open" : task?.status[0]?.status == 2 ? "Assigned" : task?.status[0]?.status == 3 && "Completed"}</span>
                                  </div>
                                </div>
                              </div>
                              <p className='mytask-price'><i className="bi bi-currency-rupee"></i> {task?.task_price}</p>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* <div className="col-lg-6">
                        <div className="member d-flex align-items-start">
                          <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                          <div className="member-info">
                            <h4>Logo testing</h4>
                            <p><i className="bi bi-calendar"></i> Nov 12, 2022</p>
                            <p><i className="bi bi-clock"></i> 10 AM - 2 PM</p>
                            <span className="badge badge-light-success">Completed</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="member d-flex align-items-start">
                          <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                          <div className="member-info">
                            <h4>Career</h4>
                            <p><i className="bi bi-calendar"></i> Jan 12, 2022</p>
                            <p><i className="bi bi-clock"></i> 10 AM - 2 PM</p>
                            <span className="badge badge-light-warning">Ongoing</span>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="member d-flex align-items-start">
                          <div className="pic"><img src={feedback} className="img-fluid" alt="" /></div>
                          <div className="member-info">
                            <h4>GST Test</h4>
                            <p><i className="bi bi-calendar"></i> Mar 12, 2022</p>
                            <p><i className="bi bi-clock"></i> 10 AM - 2 PM</p>
                            <span className="badge badge-light-warning">Ongoing</span>
                          </div>
                        </div>
                      </div> */}

                    </React.Fragment>
                  </div>

                </div>
              </section>
            </div>


          </div>
        </div>
      </section >
      <Footer />
    </React.Fragment >
  )
}

export default MakeanOfferListing;